import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=13f1ab16&"
import script from "./UserRole.vue?vue&type=script&lang=js&"
export * from "./UserRole.vue?vue&type=script&lang=js&"
import style0 from "./UserRole.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f1ab16')) {
      api.createRecord('13f1ab16', component.options)
    } else {
      api.reload('13f1ab16', component.options)
    }
    module.hot.accept("./UserRole.vue?vue&type=template&id=13f1ab16&", function () {
      api.rerender('13f1ab16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/User/UserRole.vue"
export default component.exports